<form
  class="d-flex align-items-center w-100 search"
  [formGroup]="headerSearchForm">
  <div class="d-flex align-items-center w-100 search-wrapper">
    <mat-icon class="mr-md-2 flex-shrink-0">search</mat-icon>
    <input
      class="w-100"
      name="headerSearch"
      type="text"
      formControlName="headerSearch"
      matInput
      placeholder="{{ 'header.search' | transloco }}"
      #inputRef
      #trigger="matAutocompleteTrigger"
      [matAutocomplete]="auto"
      (keyup.enter)="navigateToSearch(); trigger.closePanel()" />
    <mat-autocomplete
      class="main-nav-search-container"
      #auto="matAutocomplete"
      [displayWith]="displayEntityFn.bind(this)">
      <mat-option
        *ngFor="let option of searchItems"
        [value]="option">
        <div class="d-flex flex-row main-nav-search-item">
          <div
            class="mr-3"
            *ngIf="option.convertedType === basicEntityEnum.CARD">
            <sh-profile-logo
              class="d-block rounded-circle profile-logo"
              [fontSize]="'25px'"
              [hasLogo]="option.hasLogo"
              [id]="option.realId"
              [logoImageType]="option.imageType"
              [logoTheme]="option.profileLogoTheme ? option.profileLogoTheme : 1"
              [logoVersion]="option.profileLogoVersion ? option.profileLogoVersion : 1"
              [profileTitle]="option.text"></sh-profile-logo>
          </div>
          <div
            class="mr-3"
            *ngIf="option.convertedType === basicEntityEnum.EVENT">
            <sh-activity-preview
              class="d-block activity-logo"
              [activityTitle]="option.activityTitle"
              [fontSize]="'25px'"
              [hasLogo]="option.hasLogo"
              [id]="option.realId"
              [logoImageType]="option.imageType"
              [logoTheme]="option.activityLogoTheme ? option.activityLogoTheme : 1"
              [logoVersion]="option.activityLogoVersion ? option.activityLogoVersion : 1"></sh-activity-preview>
          </div>

          <div class="d-flex flex-column flex-grow-1 justify-content-center">
            <span
              class="font-weight-bold title"
              *ngIf="option.convertedType === basicEntityEnum.EVENT">
              {{ option.activityTitle | translateContent: translocoService.getActiveLang() }}
            </span>
            <span
              class="font-weight-bold title"
              *ngIf="option.convertedType !== basicEntityEnum.EVENT">
              {{ option.text }}
            </span>

            <span
              class="description"
              *ngIf="option.convertedType === basicEntityEnum.CARD">
              <span *ngIf="option.profileCountry">{{ option.profileCountry | translateCountry: countries$ | async }}, </span>
              <span [hidden]="!option.profileIndustry">{{ 'company-industry.' + option.profileIndustry?.toLowerCase() | transloco }} </span>
              <span [hidden]="!hashtagSearch"> ({{ highlightHashtag(option.hashtags) }})</span>
            </span>
            <span
              class="d-flex align-items-center mt-1 description"
              *ngIf="option.convertedType === basicEntityEnum.EVENT">
              <!-- ORGANIZER IS PROFILE -->
              <sh-profile-logo
                class="d-block align-items-center mr-1 rounded-circle organizer-image"
                *ngIf="basicEntityUtils.stringToEntity(option.defaultOrganizer.type) === basicEntityEnum.CARD"
                [fontSize]="'15px'"
                [hasLogo]="option.defaultOrganizer.hasLogo"
                [id]="option.defaultOrganizer.realId"
                [logoImageType]="option.defaultOrganizer.logoImageType"
                [logoTheme]="option.defaultOrganizer.profileLogoTheme ? option.defaultOrganizer.profileLogoTheme : 1"
                [logoVersion]="option.defaultOrganizer.profileLogoVersion ? option.defaultOrganizer.profileLogoVersion : 1"
                [profileTitle]="option.defaultOrganizer.text"></sh-profile-logo>
              <!-- ORGANIZER IS USER -->
              <img
                class="rounded-circle mr-1 organizer-image"
                *ngIf="basicEntityUtils.stringToEntity(option.defaultOrganizer.type) === basicEntityEnum.USER && option.organizerLogoPath"
                [attr.src]="option.organizerLogoPath" />

              <span [hidden]="!option.organizerTitle">{{ option.organizerTitle }}</span>
              <span [hidden]="!hashtagSearch"> ({{ highlightHashtag(option.hashtags) }})</span>
            </span>
          </div>
        </div>
      </mat-option>
      <mat-option
        class="show-all"
        *ngIf="searchItems && searchItems.length > 0"
        (click)="navigateToSearch()">
        <span [hidden]="searchItems.length === 0">{{ 'header.search-all' | transloco }}</span>
      </mat-option>
      <mat-option
        class="show-all"
        *ngIf="searchPerformed && searchItems && searchItems.length === 0">
        <span [hidden]="searchItems.length > 0">{{ 'header.search-none' | transloco }}</span>
      </mat-option>
    </mat-autocomplete>
  </div>
</form>
